import React, { useContext } from 'react';
import { DisplayCompType } from '../../_Common/Const/BusinessConfigs';
import { makeStyles } from 'tss-react/mui';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import { ValueType } from '../../../../Utils/Formatters/FormatterTypes';
import { themeColor } from './AktivitetTheme';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import AvenyTheme, {
  AvenyThemeDark,
} from '../../../../BaseComponents/ThemeProvider/AvenyTheme';
import classNames from 'classnames';
import BusinessDetailContext from '../../_Common/Components/BusinessDetailContext/BusinessDetailContext';
import { themeColors } from '../../../../BaseComponents/ThemeProvider/AvenyThemeColors';

interface IProps {
  value: ValueType;
  displayValue: string;
}

interface IStyleParams {
  value: ValueType;
  prelBokad: boolean;
}

const useStyles = makeStyles<IStyleParams>()((theme, props) => {
  const color =
    typeof props.value === 'string' ? themeColor(props.value) : undefined;
  return {
    cell: {
      borderRadius: theme.spacing(1),
      height: theme.spacing(4),
      minWidth: theme.spacing(18),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '4px 0',
      boxSizing: 'border-box',
    },
    backgroundColor: {
      backgroundColor: color
        ? (theme.customProperties.AktivitetColors as unknown as Record<string, string>)[color]
        : themeColors.white[1000],
    },
    backgroundColorPreliminary: {
      backgroundColor: themeColors.white[1000],
      border: `2px solid ${
        color && props.prelBokad
          ? (theme.customProperties.AktivitetColors as unknown as Record<string, string>)[color]
          : themeColors.gray[400]
      }`,
    },
  } as const;
});

const DisplayAktivitetstyp: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const businessDetailContext = useContext(BusinessDetailContext);
  const prelBokad: boolean = !!businessDetailContext.data?.PRELBOKAD;
  const { classes } = useStyles({ value: props.value, prelBokad });
  return (
    <div
      className={classNames(
        prelBokad
          ? classes.backgroundColorPreliminary
          : classes.backgroundColor,
        classes.cell
      )}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider
          theme={
            themeColor(typeof props.value === 'string' ? props.value : '')
              ? AvenyThemeDark
              : AvenyTheme
          }
        >
          <EDTypography variant="inherit" color="black">
            {props.displayValue}
          </EDTypography>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
};

const displayAktivitetstyp: DisplayCompType = DisplayAktivitetstyp;

export default displayAktivitetstyp;
